import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Single axios instance — auth carried by httpOnly cookie (set by backend on login/register).
// No tokens ever stored in localStorage / sessionStorage (XSS-resistant).
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

// ---- "View as student" instructor preview ----
// When enabled, every GET request carries ?as_student=1 and the backend
// treats the instructor as a student (read-only preview; writes unaffected).
const STUDENT_PREVIEW_KEY = "cfcs_student_preview";

export const isStudentPreview = () => sessionStorage.getItem(STUDENT_PREVIEW_KEY) === "1";

export function enterStudentPreview() {
  sessionStorage.setItem(STUDENT_PREVIEW_KEY, "1");
  window.location.assign("/dashboard");
}

export function exitStudentPreview() {
  sessionStorage.removeItem(STUDENT_PREVIEW_KEY);
  window.location.assign("/dashboard");
}

api.interceptors.request.use((config) => {
  if (isStudentPreview() && (config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), as_student: 1 };
  }
  return config;
});

// For direct-link downloads, the browser auto-attaches the httpOnly cookie
// (same site as the backend), so we just return the plain URL.
export function downloadUrl(path) {
  const sep = path.includes("?") ? "&" : "?";
  return isStudentPreview() ? `${API}${path}${sep}as_student=1` : `${API}${path}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
